// extracted by mini-css-extract-plugin
export default {"container":"ErrorPage_container__xuFXg","textContainer":"ErrorPage_textContainer__E+DlL","emoji":"ErrorPage_emoji__fosLy"};